import commonFunc from '@/common/commonFunction';

import { defaultNotificationState } from './module-notification-state';

export default {
	resetState(state) {
		Object.assign(state, defaultNotificationState);
	},
	updateNotificationList(state, res) {
		commonFunc.genVKeyValue(res.Data.Data);
		state.NotificationList.removeAll();
		state.NotificationList.append(res.Data.Data);
		state.TotalList = res.Data.Total;
	},
	updateNotificationLoaded(state, data) {
		state.notificationLoaded = data;
	},
	updateIsNewCount(state, data) {
		state.countIsNewNumber = data;
	},
	updateNotifToken(state, { token, expiry }) {
		state.notifToken = token;
		state.notifTokenExpiry = expiry;
	},
	clearNotifToken(state) {
		state.notifToken = null;
		state.notifTokenExpiry = null;
	},
	// Cập nhật trạng thái hiển thị của MISA Notification In-App v2
	updateMisaNotifShowing(state, data) {
		state.misaNotifShowing = data;
	}
};
